"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorPageLayoutFeature = void 0;
var _topArea = require("@ori/top-area");
const ErrorPageLayoutFeature = exports.ErrorPageLayoutFeature = {
  ..._topArea.TopAreaFeature
};
